import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { useField } from "vee-validate";
import { useAttrs, ref, watch, onMounted } from "vue";
import { Plus } from "@element-plus/icons-vue";
import type {
    UploadProps,
    UploadFile,
    UploadFiles,
    UploadRawFile,
    UploadUserFile,
} from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'AbitImageUpload',
  props: {
    name: {},
    label: {},
    maxfiles: {},
    horizontal: { type: [String, Boolean] },
    original: {},
    required: { type: Boolean },
    wrapperClass: {}
  },
  emits: ["onDelete"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const attrs = useAttrs();

const { value, errorMessage } = useField(props.name);

const dialogImageUrl = ref("");
const dialogVisible = ref(false);
const canAddFile = ref(true);

const fileList = ref<UploadUserFile[]>([]);

const emits = __emit;

watch(
    () => props.original,
    () => {
        fileList.value = [];
        if (props.original && props.original.length) {
            fileList.value = props.original;
            canAddFile.value = props.original.length < props.maxfiles;
        }
    },
    { immediate: true }
);


onMounted(() => {
    fileList.value = [];
    if (props.original && props.original.length) {
        fileList.value = props.original;
        canAddFile.value = ( props.original.length < props.maxfiles );
    }
}

)
const handleRemove: UploadProps["onRemove"] = (uploadFile, uploadFiles) => {
    canAddFile.value = uploadFiles.length < props.maxfiles;

    if (uploadFile.id) emits("onDelete", uploadFile.id);

    value.value = uploadFiles.map((file) => {
        const raw: UploadRawFile = file as UploadRawFile;
        return raw.raw as File;
    });
};

const handleOnChange: UploadProps["onChange"] = (
    uploadFile: UploadFile,
    uploadFiles: UploadFiles
) => {
    canAddFile.value = uploadFiles.length < props.maxfiles;
    //value.value = uploadFiles;
    value.value = uploadFiles.map((file) => {
        const raw: UploadRawFile = file as UploadRawFile;
        return raw.raw as File;
    });
};

const handlePictureCardPreview: UploadProps["onPreview"] = (uploadFile) => {
    dialogImageUrl.value = uploadFile.url!;
    dialogVisible.value = true;
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
        props.wrapperClass || 'a',
        props.horizontal && 'horizontal-wrapper',
    ])
  }, [
    _createElementVNode("label", {
      class: _normalizeClass([
            'form-label',
            props.required && 'required',
            props.horizontal && 'horizontal',
        ])
    }, _toDisplayString(props.label), 3),
    _createVNode(_component_el_form_item, {
      error: _unref(errorMessage),
      class: _normalizeClass(props.horizontal ? 'form-item-horizontal' : ''),
      validateStatus: _unref(errorMessage) ? 'error' : 'success'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_upload, {
          class: _normalizeClass(!canAddFile.value ? 'hidePlus' : 'showPlus'),
          limit: props.maxfiles,
          accept: ".jpg, .png, .jpeg",
          "file-list": fileList.value,
          "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((fileList).value = $event)),
          multiple: props.maxfiles != 1,
          name: props.name,
          "on-remove": handleRemove,
          "on-change": handleOnChange,
          "on-preview": handlePictureCardPreview,
          "list-type": "picture-card",
          "auto-upload": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Plus))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class", "limit", "file-list", "multiple", "name"]),
        _createVNode(_component_el_dialog, {
          modelValue: dialogVisible.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              class: "w-100",
              src: dialogImageUrl.value,
              alt: "Preview Image"
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["error", "class", "validateStatus"])
  ], 2))
}
}

})